interface LogoProps {
  className?: string;
}

export function PhysicalGoldTrackerLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M35.19,20.66l5,1.31,2.9,4.34c.06.29.03.54-.18.76-1.58,1.74-2.94,3.85-4.51,5.57-.21.23-.44.56-.78.49l-12.62-3.66-8.53,7.38c-.34.09-.5,0-.76-.18-2.33-1.53-4.5-3.76-6.84-5.33l-.23-.37.7-4.68,15.99-13.13.34-.04,6.08,3.11,3.59,3.35c.32.49.02.65-.15,1.08ZM25.61,14.54l-14.61,12.05,4.18,3.14.16.03,14.76-12.87-4.5-2.34ZM33.77,20.06l-2.5-2.46-15.12,13.25-.07.29.59,3.78,17.1-14.86ZM38.63,22.82l-4.73-1.18c-1.15,1.05-2.39,2.02-3.48,3.12l5.7,1.55,2.51-3.49ZM39.78,23.65l-2.63,3.63c.32,1.08.43,2.39.79,3.44.03.09.02.19.12.25l3.61-4.45-1.9-2.86ZM35.85,27.62l-6.59-1.81c-.12,0-.21.08-.3.15-.7.49-1.69,1.45-2.35,2.05-.06.05-.4.38-.37.41l10.53,3.06-.91-3.87ZM14.71,30.98l-4.31-3.16c-.07.9-.36,1.8-.34,2.69l5.15,4.11c.18.02.09-.05.08-.15-.12-1.14-.41-2.34-.59-3.48Z" 
      />
    </svg>
  );
}